import { Component, OnChanges, EventEmitter, Output, Input, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import * as randomize from "randomatic";
import { PipelineDetails } from '@cradua/domain';
import { PipelineDetailsDto, UomDto, LicenceStatusDto, 
  AssetStatusDto, PigibilityDto, PipelineAssetLocationDto, 
  DeliveryTypeDto, NetworkDto, IPStatusDto, PipelineGradeDto, 
  AccountableFunctionLink2Dto, PipelineAssetLink2Dto, PipelineSectionDto, 
  AccountableFunctionDto,LandTitleDto, FunctionDto, CategoryDto, SubSubGroupDto, OpllPtsHistoryDto, } from '@cradua/data';
  import { Guid } from 'guid-typescript';

@Component({
  selector: 'cradua-pipelinedetails',
  templateUrl: './pipelinedetails.component.html',
  styleUrls: ['./pipelinedetails.component.scss']
})

export class PipelinedetailsComponent implements OnChanges {
  @Input() loggedInUser: any;
  @Input() assetstatuss: AssetStatusDto[];
  @Input() pigibilitys: PigibilityDto[];
  @Input() assetlocations: PipelineAssetLocationDto[];
  @Input() deliverytypes: DeliveryTypeDto[];
  @Input() licencestatuss: LicenceStatusDto[];
  @Input() uomes: UomDto[];
  @Input() networks: NetworkDto[];
  @Input() ipstatuss: IPStatusDto[];
  @Input() pipelinegrades: PipelineGradeDto[];
  @Input() landTitles: LandTitleDto[];
  @Input() subsubgroups: SubSubGroupDto[];
  @Input() categorys: CategoryDto[];
  @Input() acountablefunctionlink2s: AccountableFunctionLink2Dto[];
  @Input() opllptshistorys: OpllPtsHistoryDto[];
  @Input() pipelineassets: any[];
  @Input() pipelineassetlink2s: PipelineAssetLink2Dto[];
  @Input() accountablefunctions: AccountableFunctionDto[];
  @Input() functions: FunctionDto[];
  @Input() pipelinesections: PipelineSectionDto[];
  @Input() pipelineDetails: any[];
  @Output() submitPipelineEvent = new EventEmitter<PipelineDetails>();
  @Output() onNextEvent = new EventEmitter<any>();
  @Output() emitAssetSave = new EventEmitter<PipelineDetailsDto[]>();
  @Output() emitFxtSave = new EventEmitter<PipelineDetailsDto[]>();
  @Output() onBackEvent = new EventEmitter<any>();
  @Output() emitFxtDelete = new EventEmitter<any>();
  @Output() emitAssetDelete = new EventEmitter<any>();
  @Output() emitSectionSave = new EventEmitter<PipelineSectionDto[]>();
  @Output() emitSectionDelete = new EventEmitter<any>();
  years=[];
  accountablefunction: AccountableFunctionDto[];
  pipelineasset: LandTitleDto[];
  function: FunctionDto[];
  category: CategoryDto[];
  subsubgroup: SubSubGroupDto[];

  Pipelineview: any;
  pipelineForm: FormGroup;
  PipelineData: PipelineDetailsDto;
  newObject: any[] & PipelineDetailsDto[];
  searchPipelineDetailsValue = '';
  searchedPipelineDetails: PipelineDetailsDto[] | any[];
  selectedValue: PipelineDetailsDto;
  submittedId;
  selectedPipelineDetails: PipelineDetailsDto;
  showTab = false;
  isExpanded = true;
  loggedInUserDetail: any;

  constructor(
      private fb: FormBuilder
  ) {
    const year = new Date().getFullYear();
    for(let i=0; i<100; i++){
      
      this.years.push(year-i)
    }
  }

  ngOnChanges(change: SimpleChanges): void {
    this.loggedInUserDetail = this.loggedInUser != null ? this.loggedInUser.user : null;
    this.createPipelineForm();
    if(this.pipelineDetails && this.pipelineDetails.length) {
      this.selectedPipelineDetails = this.pipelineDetails[0];
      this.onViewOrEdit(this.pipelineDetails[0]);
      this.showTab = true;
    } else {
      this.showTab = false;
      this.selectedPipelineDetails = null;
      // this.onChangeLandCodeGenerator();
    }   
  }

  onViewOrEdit(selectedValue: PipelineDetailsDto) {
    // console.log("patch value: ", selectedValue);
    if(selectedValue) {
      // selectedValue.InstallationDate = this.dateTransformation(selectedValue.InstallationDate);
      // selectedValue.LicenceExpirationDate = this.dateTransformation(selectedValue.LicenceExpirationDate);
      this.pipelineForm.patchValue({
        PipelineCode: selectedValue.PipelineCode,
        PipelineName: selectedValue.PipelineName,
        OPLLNumber: selectedValue.OPLLNumber,
        PTSNumber: selectedValue.PTSNumber,
        InstallationYear: selectedValue.InstallationYear,
        LicenceStatusId: selectedValue.LicenceStatusId,
        LicenceExpirationDate: this.dateTransformation(selectedValue.LicenceExpirationDate),
        id: selectedValue.id
      });
    }
  }

  onChangeLandCodeGenerator() {
    if(this.selectedPipelineDetails === null) {
      const generatedCode = `PLND${randomize("0", 6)}`
      this.pipelineForm.patchValue({PipelineCode: generatedCode});
      // this.pipelineForm.controls['PipelineCode'].disable()
    } 
    // else {
    //   if(this.acquisitionForm.controls['LandCode'].status === 'DISABLED') {
    //     this.acquisitionForm.controls['LandCode'].enable();
    //     this.acquisitionForm.patchValue({LandCode: ''});
    //   }
    // }
  }

  createPipelineForm() {
    this.pipelineForm = this.fb.group({
      PipelineCode: ['', Validators.required],
      PipelineName: ['', Validators.required],
      InstallationYear: ['', Validators.required],
      OPLLNumber: [''],
      PTSNumber: [''],
      DeliveryTypeId: null,
      AssetStatusId: null,
      NetworkId: null,
      PigibilityId: null,
      PipelineAssetLocationId: null,
      IpStatusId: null,
      PipelineGradeId: null,
      LicenceStatusId: null,
      LicenceExpirationDate: ['', Validators.required],
      Length: null,
      Diameter: null,
      WallThickness: null,
      DesignedPressure: null,
      LengthUOMId: null,
      DiameterUOMId: null,
      WallThicknessUOMId: null,
      DesignedPressureUOMId: null,
      SubscriberId: ['0'],
      SubscriptionUserId: ['0'],
      createdAt: [''],
      updatedAt: [''],
      id:  Guid.create().toString(),
    });
  }

  public errorHandling = (control: string, error: string) => {
    return this.pipelineForm.controls[control].hasError(error);
  };

  search(value: string) {
    !value
      ? (this.searchedPipelineDetails = null)
      : (this.searchedPipelineDetails = this.pipelineDetails.filter(
          (item) =>
            item.PipelineName.toLowerCase().includes(value.toLowerCase()) ||
            item.PipelineCode.toLowerCase().includes(value.toLowerCase())
        ));
  }

  addPipelineDetails(value) {
    // Not in use!!!
    this.pipelineForm.patchValue({
      PipelineCode: value.PipelineCode,
      PipelineName: value.PipelineName,
      OPLLNumber: value.OPLLNumber,
      PTSNumber: value.PTSNumber,
      InstallationYear: value.InstallationYear,
      LicenceStatusId: value.LicenceStatusId,
      LicenceExpirationDate: this.dateTransformation(value.LicenceExpirationDate),
    });
  }

  dateTransformation(date) {
    let d = new Date(date);
    let day = '' + d.getDate();
    let month = '' + (d.getMonth() + 1);
    let year = d.getFullYear();

    if (month.length < 2) {
      month = '0' + month;
    }

    if (day.length < 2) {
      day = '0' + day;
    }
    return [year, month, day].join('-');
  }

  tabChanged(tabChangeEvent): void {
    // console.log('tabChangeEvent => ', tabChangeEvent);
    // // this.selectedTabIndex = 7;
    // console.log('index => ', tabChangeEvent);
    this.isExpanded = false;
  }

  onCreate() {
    // this.sektion = true;
    this.pipelineForm.reset();
  }

  getPipelineDetails(id){
     this.pipelineDetails.find(p => p.id === id);
  }

  onEmitSektionSubmit(value: PipelineSectionDto[]) {
    this.emitSectionSave.emit(value);
  }

  getPipeline(id) {
    return this.pipelineDetails.find(pipeline => pipeline.PipelineCode === id);
  }
  
  onNextLine(value) {
    this.onNextEvent.emit(value);
  }

  onBackLine() {
    this.onBackEvent.emit();
  }

  onEmitSectionDelete(valueIndex) {
    this.emitSectionDelete.emit(valueIndex);
  }

  onEmitAssetDelete(valueIndex) {
    this.emitAssetDelete.emit(valueIndex);
  }

  onEmitFxnDelete(valueIndex) {
    this.emitFxtDelete.emit(valueIndex);
  }

  onEmitAssetSubmit(formValue) {
    this.emitAssetSave.emit(formValue);
  }

  onEmitFxnSubmit(formValue) {
    this.emitFxtSave.emit(formValue);
  }

  onSubmit(formValue: any) {
    // this.onNextLine(this.selectedPipelineDetails);
    if(this.pipelineForm.invalid) {
      return;
    }
    this.showTab = true;
      this.submitPipelineEvent.emit(formValue);
  }
}
